/**
 * @module Worker
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable:no-any */ // We need this as preflight and fallback arguments can be anything
// We are not able to get the exact type of variable so need to discuss with concerned developer

import { WorkerRequestArgs } from '@core/worker/models/worker-request-args';
import { HttpHeaders } from '@angular/common/http';
import { WorkerUtils } from '@core/worker/models/utils';

export class WorkerRequest {
  public url: string;

  public method: string = 'GET';

  public queryParams: { [key: string]: string };

  public headers: { [name: string]: string };

  public body: any;

  public preferCache: boolean = false;

  public cacheResponse: boolean = false;

  public cacheFallback: boolean = false;

  public cacheKey: string;

  public queue: boolean = false;

  public preflight: (...args: any[]) => any;

  public fallback: object | string;

  public retry: boolean = false;

  public validateRequest: boolean = false;

  public validateResponse: boolean = false;

  public swaggerUrl: string;

  public ttl: number;

  constructor(url: string, method?: string, args: WorkerRequestArgs = {}) {
    this.url = url;
    if (this.method) {
      this.method = WorkerUtils.flattenRequestMethod(method).toLocaleUpperCase();
    }
    if (args) {
      this.mergeArgs(args);
    }
  }

  private mergeArgs(args: WorkerRequestArgs): void {
    // if (args.params) {
    //   this.queryParams = args.params;
    // }
    // if (args.headers) {
    //   this.headers = args.headers.toJSON();
    // }
    // if (args.body) {
    //   this.body = args.body;
    // } else {
    //   this.body = null;
    // }
    // if (args.preferCache) {
    //   this.preferCache = args.preferCache;
    // }
    // if (args.cache) {
    //   this.cache = args.cache;
    // }
    // if (args.queue) {
    //   this.queue = args.queue;
    // }
    // if (args.preflight) {
    //   this.preflight = args.preflight;
    // }
    // if (args.fallback) {
    //   this.fallback = args.fallback;
    // }
    // if (args.retry) {
    //   this.retry = args.retry;
    // }

    this.queryParams = args.params;
    this.body = args.body;
    this.cacheKey = args.cacheKey;
    this.preferCache = args.preferCache;
    this.cacheResponse = args.cacheResponse;
    this.cacheFallback = args.cacheFallback;
    this.queue = args.queue;
    this.preflight = args.preflight;
    this.fallback = args.fallback;
    this.retry = args.retry;
    this.validateRequest = args.validateRequest;
    this.validateResponse = args.validateResponse;
    this.swaggerUrl = args.swaggerUrl;
    this.ttl = args.ttl;
    if (args.headers) {
      this.headers = this.flattenHeaders(args.headers);
    }
  }

  private flattenHeaders(headers: HttpHeaders): { [name: string]: string } {
    const flattenedHeaders: { [name: string]: string } = {};
    headers.keys().map((key: string) => {
      flattenedHeaders[key] = headers.get(key) ? headers.get(key).toString() : '';
    });
    return flattenedHeaders;
  }
}
